
import { authToken, axiosHeader } from '../../utils/helper';
import { ablBaseUrl, baseUrl } from '../../utils/sysEnv';
import * as types from '../types'
import axios from "axios";
import { toast } from "react-toastify";
import { deleteCookie, setCookie } from 'cookies-next';


const header = token => {
  // loggedIn user authorized token header
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
  return {headers: headers};
};


export const login = data => async dispatch => {
  try {
    dispatch({
      type: types.LOG_OUT, 
      payload: {},
    });
    deleteCookie('loggedInUser');
    dispatch({ type: types.SET_LOADING });
    await axios
      .post(`${baseUrl}/auth/ad/login`, data)
      .then(res => {
          let token = res.data.token;

          axios
          .get(`${baseUrl}/admins/user`, header(res.data.token))
          .then(tmpUser => {
              let newUser = tmpUser.data.data;
              toast.success('Login Success');
              newUser.token = token;
            dispatch({
              type: types.LOGIN,
              payload: newUser,
            });
            setCookie('loggedInUser', JSON.stringify(newUser))
            setCookie('ablToken', res.data.ablToken)
            if(newUser){
                window.location = "/dashboard"; 
            }   
          })
          .catch(error => {
            toast.error('error', 'oops there was an error');
            dispatch({ type: types.RESET });
          });
        


      })
      .catch(error => {
      toast.error(error.response.data.error)
      dispatch({ type: types.RESET });
      });
  } catch (error) {
    dispatch({ type: types.RESET });
      toast.error(error)
  //   errorFunction(error, dispatch, types.RESET_AUTH);
  //   reset(types.RESET_CREATE);

  }
};


// get client info from accessbank api
export const accessbankLogin = () => async (dispatch) => {
  try {
    dispatch({ type: types.SET_LOADING });
    await axios
      .post(`${baseUrl}/auth/abl`)
      .then((res) => {
        dispatch({
          type: types.LOGIN,
          payload: res.data.data,
        });
        // window.location = '/'

        // toast.success('Login Success')
      })
      .catch((error) => {
            toast.error(error.response.data.error);
          //   setError(dispatch, error.response.data.error)
        
      });
  } catch (err) {
      toast.error(err);
  }
};


export const createClient = data => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .post(`${baseUrl}/auth/register`, data, axiosHeader(data.token))
        .then((res) => {
          dispatch({
            type: types.CREATE_USER,
            payload: res.data.data,
          });
          window.location = "/clients";
        })
        .catch((error) => {
          if (error.response === undefined) {
          // window.location = "/clients";
            toast.error(error.response.data.error);
            dispatch({ type: types.RESET_LOADING });
          } else {
             toast.error(error.response.data.error);
             dispatch({ type: types.RESET_LOADING });
          }
        });
    } catch (err) {
      dispatch({ type: types.SET_ERROR });
       toast.error(err.message.data.error);
    }
  };

  // get client info from accessbank api
export const verifyClientInfo = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .get(`${ablBaseUrl}/Customers/${info.customerId}/ActiveAccounts`, authToken(info.token))
        .then((res) => {


        //   dispatch({
        //     type: types.GET_TARIFFS,
        //     payload: res.data.data,
        //   });


        })
        .catch((error) => {
          if (error.response === undefined) {
            toast.error("axios error", error.message.data.error);
            //   setError(dispatch, error.message)
          } else {
             toast.error("axios error", error.response.data.error);
            //   setError(dispatch, error.response.data.error)
          }
        });
    } catch (err) {
       toast.error("axios error", err.message.data.error);
    }
  };


  export const logout = () => async dispatch => {
    try {

          //dispatch the log out function to remove the login user from global state and
          dispatch({
            type: types.LOG_OUT,
            payload: {},
          });
          deleteCookie('loggedInUser');
          deleteCookie('ablToken');
          window.location = "/"; 
          toast.success('Successfully LoggedOut')
        
    } catch (error) {
        toast.error(error)
      throw error;
    }
  

  };